import * as O from 'fp-ts/lib/Option'

import { EuroCents } from '@espoon-voltti/ts-libs/lib/euro'

import {
  AttachmentModel,
  PublishedAttachment
} from '@espoon-voltti/react-voltti/components/attachment-selector/domain/model'

import { Org } from '@espoon-voltti/nuora-domain/applicants'
import { Attachment, Transaction } from '@espoon-voltti/nuora-domain/grants'

import { AttachmentDto } from './attachment'
import { TransactionDto } from './form-data'
import { OrgDto } from './org'

export const orgDtoToDomain = (x: OrgDto): Org => ({
  ...x,
  attachments: x.attachments.map(AttachmentMapper.fromDto)
})

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace AttachmentMapper {
  export const modelFromDto = (dto: AttachmentDto): AttachmentModel =>
    PublishedAttachment.of({
      name: dto.name,
      path: dto.path,
      version: O.fromNullable(dto.version)
    })

  export const modelToDto = (model: AttachmentModel): AttachmentDto => ({
    path: model.attachment.path,
    name: model.attachment.name,
    version: O.toNullable(model.attachment.version)
  })

  export const fromDto = (dto: AttachmentDto): Attachment => ({
    name: dto.name,
    path: dto.path,
    version: O.fromNullable(dto.version)
  })

  export const toDto = (domain: Attachment): AttachmentDto => ({
    name: domain.name,
    path: domain.path,
    version: O.toNullable(domain.version)
  })
}

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace TransactionMapper {
  // NOTE used by nuora/user, nuora/admin takes different approach
  export const draftsFromDtos = (dtos: TransactionDto[]): Transaction[] => {
    if (dtos.length > 0) {
      return dtos.map(fromDto)
    }

    // NOTE this is the approach from KultA (as of 30.6.2020), by ensuring that
    // one row exists probably makes view state management easy ?!
    return [
      {
        description: '',
        amount: EuroCents.zero()
      }
    ]
  }

  export const fromDto = (dto: TransactionDto): Transaction => ({
    description: dto.description,
    amount: EuroCents.fromValue(dto.amountInCents ?? 0)
  })

  export const toDto = (domain: Transaction): TransactionDto => ({
    description: domain.description,
    amountInCents: domain.amount.cents
  })
}
